import styled, { css } from 'styled-components';
import { TabContainer } from '../Tabs-styled';


export const MaterialSectionContainer = styled.div`
  & ~ & {
    margin-top: 30px;
  }
`;

export const MaterialSectionHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const MaterialSectionHeaderLeftSide = styled.div`
  margin-left: 3px;
`;

export const MaterialSectionHeaderRightSide = styled.div`
  margin-right: 3px;
`;

export const MaterialSectionHeaderTopText = styled.div`
`;

export const MaterialSectionHeaderBottomText = styled.div`
  font-weight: bold;
  text-transform: uppercase;
`;

export const PuritySectionContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
`;

export const PuritySelectorContainer = styled(MaterialSectionContainer)`
  display: flex;
  height: 100%;
`;

export const PuritySelectorOption = styled.div<{isSelected:boolean}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  border: 1px solid ${(props) => props.theme.colors.darkGray};
  cursor: pointer;

  margin: 3px;

  &:last-of-type {
    margin-right: 0px; //already handled by container element
  }
  
  ${(props) => props.isSelected && css`
    border-color: ${(props) => props.theme.colors.backgroundBlack};
  `}
`;

export const MaterialsTabContainer = styled(TabContainer)`
  ${(props) => props.mobile && css`
    ${MaterialSectionContainer} ~ ${MaterialSectionContainer} {
      margin-top: ${25 * props.menuScaleFactor}px;
    };

    ${PuritySectionContainer} {
      min-height: ${35 * props.menuScaleFactor}px;
    };

    ${PuritySelectorContainer} {
      min-height: ${32 * props.menuScaleFactor}px;
    };

    ${PuritySelectorOption} {
      margin-top: 0px;
      margin-bottom: 0px;
    };

    ${MaterialSectionHeaderLeftSide} {
      margin-left: 3px;
      display: flex;
      align-items: center;
      font-size: ${12 * props.menuScaleFactor}px;
    };

    ${MaterialSectionHeaderLeftSide} {
      margin-right: 0px;
    };

    ${PuritySelectorOption} {
      width: ${60 * props.menuScaleFactor}px;
      font-size: ${12 * props.menuScaleFactor}px;
    };
  `}
`;